import Vue from 'vue'
import Router, { Route } from 'vue-router'
import store from './store'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { userType, common, errorFlag } from '@/app/model/store/domain/const'
import state from './app/model/store/domain/AccountState/state'
import AlertState from './app/model/store/domain/AlertState'
Vue.use(Router)

declare module 'vue-router/types/router' {
  interface VueRouter {
    go(n: number|{[key: string]: string|boolean}) : void
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // 共通
    {
      path: '/',
      redirect: 'field'
    },
    {
      path: '/login',
      name: 'ログイン',
      component: () => import('./views/Login.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE
        ],
        beforeLoginPage: true,
        title: 'ログイン | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder',
      name: 'パスワードリマインダー',
      component: () => import('./views/PasswordReminder.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE
        ],
        beforeLoginPage: true,
        title: 'パスワードリマインダー | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder/:uq_key',
      name: 'パスワード再設定',
      component: () => import('./views/PasswordResetting.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE
        ],
        beforeLoginPage: true,
        title: 'パスワード再設定 | ' + common.SYSTEM_NAME
      }
    },
    // サービス画面
    {
      path: '/field',
      name: 'マップ・圃場一覧',
      component: () => import('./views/Field.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'マップ・圃場一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board',
      name: '栽培指導広報',
      component: () => import('./views/NewsBoard.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/create',
      name: '栽培指導広報追加',
      component: () => import('./views/NewsBoardCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id',
      name: '栽培指導広報詳細',
      component: () => import('./views/NewsBoardDetails.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/edit',
      name: '栽培指導広報編集・削除',
      component: () => import('./views/NewsBoardCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/create',
      name: '栽培指導広報記事追加',
      component: () => import('./views/NewsBoardContentCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/:news_board_content_id',
      name: '栽培指導広報記事編集・削除',
      component: () => import('./views/NewsBoardContentCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/:news_board_content_id/pdf-preview',
      name: '栽培指導広報PDFプレビュー',
      component: () => import('./views/NewsBoardPdfPreview.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link',
      name: '外部連携',
      component: () => import('./views/ExternalLink.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/create',
      name: '外部連携追加',
      component: () => import('./views/ExternalLinkCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id',
      name: '外部連携詳細',
      component: () => import('./views/ExternalLinkDetails.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/edit',
      name: '外部連携編集・削除',
      component: () => import('./views/ExternalLinkCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/create',
      name: '外部連携連携追加',
      component: () => import('./views/ExternalLinkContentCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/:external_link_content_id',
      name: '外部連携連携編集・削除',
      component: () => import('./views/ExternalLinkContentCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/:external_link_content_id/pdf-preview',
      name: '外部連携PDFプレビュー',
      component: () => import('./views/ExternalLinkPdfPreview.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/order',
      name: '収穫指示',
      component: () => import('./views/FieldOrder.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '収穫指示 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/:field_id',
      name: '圃場詳細',
      component: () => import('./views/FieldDetails.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: '圃場詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/profit',
      name: '収益予実',
      component: () => import('./views/Profit.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '収益予実 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/mypage',
      name: 'マイページ',
      component: () => import('./views/MyPage.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'マイページ | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/error-page',
      name: 'エラーページ',
      component: () => import('./views/ErrorPage.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE,
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ]
      }
    },
    // マスタ画面
    {
      path: '/master',
      name: 'マスタ管理トップ',
      component: () => import('./views/Master.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'マスタ管理トップ | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user',
      name: 'ユーザー管理',
      component: () => import('./views/Account.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'ユーザー管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user/create',
      name: 'ユーザー追加',
      component: () => import('./views/AccountCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'ユーザー追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user/:user_id',
      name: 'ユーザー編集・削除',
      component: () => import('./views/AccountEdit.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'ユーザー編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group',
      name: 'グループ管理',
      component: () => import('./views/Group.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'グループ管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group/create',
      name: 'グループ追加',
      component: () => import('./views/GroupCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'グループ追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group/:group_id',
      name: 'グループ編集・削除',
      component: () => import('./views/GroupEdit.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION
        ],
        title: 'グループ編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area',
      name: '地域管理',
      component: () => import('./views/Area.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地域管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area/create',
      name: '地域追加',
      component: () => import('./views/AreaCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地域追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area/:area_id',
      name: '地域編集・削除',
      component: () => import('./views/AreaCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地域編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district',
      name: '地区管理',
      component: () => import('./views/District.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地区管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district/create',
      name: '地区追加',
      component: () => import('./views/DistrictCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地区追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district/:district_id',
      name: '地区編集・削除',
      component: () => import('./views/DistrictCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '地区編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk',
      name: '収穫リスク管理',
      component: () => import('./views/Risk.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '収穫リスク管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk/create',
      name: '収穫リスク追加',
      component: () => import('./views/RiskCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '収穫リスク追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk/:risk_id',
      name: '収穫リスク編集・削除',
      component: () => import('./views/RiskCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '収穫リスク編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety',
      name: '品種管理',
      component: () => import('./views/Variety.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety/create',
      name: '品種追加',
      component: () => import('./views/VarietyCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety/:variety_id',
      name: '品種編集・削除',
      component: () => import('./views/VarietyCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth',
      name: '品種生育管理',
      component: () => import('./views/VarietyGrowth.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種生育管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth/create',
      name: '品種生育追加',
      component: () => import('./views/VarietyGrowthCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種生育追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth/:variety_growth_id',
      name: '品種生育編集・削除',
      component: () => import('./views/VarietyGrowthCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '品種生育編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant',
      name: '作付け管理',
      component: () => import('./views/Plant.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '作付け管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant/create',
      name: '作付け追加',
      component: () => import('./views/PlantCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '作付け追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant/:plant_id',
      name: '作付け編集・削除',
      component: () => import('./views/PlantCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '作付け編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field',
      name: '圃場管理',
      component: () => import('./views/MasterField.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '圃場管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field/create',
      name: '圃場追加',
      component: () => import('./views/MasterFieldCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '圃場追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field/:field_id',
      name: '圃場編集・削除',
      component: () => import('./views/MasterFieldCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER
        ],
        title: '圃場編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice',
      name: 'AIアドバイス管理',
      component: () => import('./views/MasterAiAdvice.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'AIアドバイス管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice/create',
      name: 'AIアドバイス追加',
      component: () => import('./views/MasterAiAdviceCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'AIアドバイス追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice/:ai_advice_id',
      name: 'AIアドバイス編集・削除',
      component: () => import('./views/MasterAiAdviceCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'AIアドバイス編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    // スマホ
    {
      path: '/sp',
      redirect: '/sp/field'
    },
    {
      path: '/sp/login',
      name: 'ログイン',
      component: () => import('./views/SpLogin.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE
        ],
        beforeLoginPage: true,
        title: 'ログイン | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field',
      name: 'マップ・圃場一覧',
      component: () => import('./views/SpField.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: 'マップ・圃場一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id',
      name: '圃場・作付け詳細',
      component: () => import('./views/SpFieldDetails.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: '圃場・作付け詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/create',
      name: '作付け生育記録追加',
      component: () => import('./views/SpFieldRecordCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: '作付け生育記録追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/:record_date',
      name: '作付け生育記録一覧',
      component: () => import('./views/SpFieldRecord.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: '作付け生育記録一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/:record_date/edit',
      name: '作付け生育記録編集・削除',
      component: () => import('./views/SpFieldRecordCreate.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_ALL_VIEWER
        ],
        title: '作付け生育記録編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/error-page',
      name: 'エラーページ',
      component: () => import('./views/SpErrorPage.vue'),
      meta: {
        canViewUserType: [
          userType.USER_TYPE_NONE,
          userType.USER_TYPE_ADMIN,
          userType.USER_TYPE_OPERATION,
          userType.USER_TYPE_FARM_ADMIN,
          userType.USER_TYPE_FARM_WORKER,
          userType.USER_TYPE_VIEWER,
          userType.USER_TYPE_ALL_VIEWER
        ]
      }
    },
    {
      path: '/sp*',
      redirect: '/sp/field'
    },
    {
      path: '*',
      redirect: 'field'
    }
  ]
})

/* 運用管理からアクセスした場合 */
router.beforeEach((to, from, next) => {
  const authCookie = Vue.$cookies.get(process.env.VUE_APP_COOKIE_NAME)
  if (authCookie !== null) {
    Vue.$cookies.remove(process.env.VUE_APP_COOKIE_NAME, '', process.env.VUE_APP_COOKIE_DOMAIN)
    const user = Local.getAuthToken()
    if (user) {
      CommonClass.forceLogout()
    }
    CommonClass.adminUserSignin(authCookie)
  }
  next()
})

/* ログイン済みの場合のチェック処理 */
router.beforeEach((to, from, next) => {
  const hasAuthToken = Local.getAuthToken()
  if (hasAuthToken) {
    loggedInUserCheck(to, from, next)
  }
  next()
})

const loggedInUserCheck = async (to: Route, from: Route, next: any) => {
  // 認証チェック
  await CommonClass.authCheck()
  let device = ''
  if (to.path.indexOf('/sp') !== 0) {
    device = 'pc'
  } else {
    device = 'sp'
  }
  // 栽培タイトルチェック
  await CommonClass.setServiceFunctionData(device)
  // 認証チェック（同じ画面を表示中、30分毎に認証チェック）
  await CommonClass.consecutiveCheck(device)
  // システム定義チェック
  await CommonClass.constantValueCheck(to.path)
  next()
}

/* エラーページ遷移制御 */
router.beforeEach((to, from, next) => {
  const hasAuthToken = Local.getAuthToken()
  const state: any = store.state

  if (to.path === '/sp/error-page' || to.path === '/error-page') {
    // 遷移先がエラーページ
    if (state.routeState.errorFlag === 0) {
      // エラーフラグが立っていない場合（エラーページは直接アクセス不可）
      let redirectPath = ''
      if (hasAuthToken) {
        redirectPath = 'field'
      } else {
        redirectPath = 'login'
      }

      if (to.path.indexOf('/sp') === 0) {
        next({
          path: '/sp/' + redirectPath
        })
      } else {
        next({
          path: '/' + redirectPath
        })
      }
    } else {
      // エラーフラグが立っている場合
      next()
    }
  } else {
    // 遷移先がエラーページ以外
    next()
  }
})

/* 閲覧権限 */
router.beforeEach((to, from, next) => {
  const hasAuthToken = Local.getAuthToken()
  const canViewUserType = to.meta.canViewUserType
  let hasUserType: null|string|number = Local.getUserType()

  if (hasUserType !== null) {
    hasUserType = parseInt(hasUserType)
  }

  if (canViewUserType.includes(hasUserType)) {
    next()
  } else {
    let redirectPath = ''
    const beforeLoginPage = to.matched.some(record => record.meta.beforeLoginPage)
    if (hasAuthToken) {
      if (beforeLoginPage) {
        // ログイン中のユーザーは、ログイン、パスワードリマインダー画面のアクセスは不可
        redirectPath = 'field'
      } else {
        // 権限のないユーザーは403ページを表示
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_AUTH)
        redirectPath = 'error-page'
      }
    } else {
      redirectPath = 'login'
    }
    if (to.path.indexOf('/sp') === 0) {
      next({
        path: '/sp/' + redirectPath
      })
    } else {
      next({
        path: '/' + redirectPath
      })
    }
  }
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
